import { SHOWN_EVENT_MODALS_KEY } from '../constants';

export const getEventModalShownDatesFromLS = (): string[] => {
  return JSON.parse(localStorage.getItem(SHOWN_EVENT_MODALS_KEY) || '[]');
};

export const addNewDateToShownDatesLS = (date: string) => {
  const datesFromLs = getEventModalShownDatesFromLS();

  datesFromLs.push(date);
  localStorage.setItem(SHOWN_EVENT_MODALS_KEY, JSON.stringify(datesFromLs));
};

export const removeEventModalShownDatesFromLS = () => {
  localStorage.removeItem(SHOWN_EVENT_MODALS_KEY);
};
